import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Injector } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { SessionService } from "src/app/services/session.service";
import { tap, catchError } from "rxjs/operators";
import { AuthService } from "src/app/services/auth.service";
import { StartupService } from '../startup.service';
import { environment } from '../../environments/environment';

export class AuthInterceptor implements HttpInterceptor {
    constructor(private readonly inj: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler/*  | any */): Observable<HttpEvent<any>> {
        // req.headers.set('withCredentials', 'true');
        const session = this.inj.get(SessionService);
        const authService = this.inj.get(AuthService);
        const startupService = this.inj.get(StartupService);
        let modReq: HttpRequest<any>;
        let modified = false;

       // if (!session.getToken()) {
           // if ((window.location.href.indexOf('admin') == -1 && window.location.href.indexOf('suppliers') !== -1) || environment.localvsp) {
                if (authService.getAuthHeader() && authService.getAuthHeader().length > 0) {
                    modReq = req.clone({ setHeaders: { 'Authorization': authService.getAuthHeader() } });
                    modified = true;
                }
            //}
            // else {
            //     modReq = req.clone({ setHeaders: { 'tonicid': session.getToken() } });
            //     console.log("modreq", modReq);
            //     modified = true;
            // }
        //}
        // else {
        //     modReq = req.clone({ setHeaders: { 'tonicid': session.getToken() } });
        //     console.log("modreq", modReq);
        //     modified = true;
        // }

        return next.handle(modified ? modReq : req)
            .pipe(tap(event => {
                if (event instanceof HttpResponse) {
                    if (event.headers.get('tonicid')) {
                        session.setToken(event.headers.get('tonicid'));
                    }
                    else{}
                }
            }), catchError((err:any, caught) => {
                if(err instanceof HttpErrorResponse){
                    console.log('Unable to authenticate', err);
                    if (err.error.message && err.error.message.indexOf('jwt expired') !== -1) startupService.load();
                }
                throw err;
            }));
    }

}